import { render } from "./SocialNav.vue?vue&type=template&id=32c7021c&scoped=true"
import script from "./SocialNav.vue?vue&type=script&lang=js"
export * from "./SocialNav.vue?vue&type=script&lang=js"

import "./SocialNav.vue?vue&type=style&index=0&id=32c7021c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32c7021c"

export default script